import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup, Input } from 'reactstrap';
import { ExploritNavIcon } from '../exploritNavIcon';
import { FONT_AWESOME_GLYPHS, ICOMOON_GLYPHS } from '../navIconScale';

const NavGlyphPicker = ({ icon, onSelect, onClose, logoUri = '' }) => {
    const { t } = useTranslation();
    const current_font = icon?.type === 'font-awesome' ? 'font-awesome' : 'icomoon';
    const [font, setFont] = useState(current_font);
    const [query, setQuery] = useState('');

    const names = font === 'font-awesome' ? FONT_AWESOME_GLYPHS : ICOMOON_GLYPHS;
    const visible = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q)
            return names;
        return names.filter((name) => name.toLowerCase().includes(q));
    }, [names, query]);

    const is_current = (type, name) => {
        if (type === 'logo')
            return icon?.type === 'logo';
        const stored = icon?.type === 'explorit' ? 'icomoon' : icon?.type;
        return stored === type && icon?.name === name;
    };

    return (
        <div className="tab-chooser-backdrop">
            <div className="tab-chooser glyph-chooser">
                <Button type="button" className="close-btn" color="link" onClick={ onClose }>
                    <i className="fa fa-times" />
                </Button>
                <div className="small card-title">
                    { t('settings.mobile.navigation.choose_icon') }
                </div>
                <ButtonGroup className="glyph-chooser-fonts">
                    <Button
                        type="button"
                        size="sm"
                        color={ font === 'font-awesome' ? 'warning' : 'secondary' }
                        onClick={ () => setFont('font-awesome') }
                    >
                        { t('settings.mobile.navigation.icon_font_awesome') }
                    </Button>
                    <Button
                        type="button"
                        size="sm"
                        color={ font === 'icomoon' ? 'warning' : 'secondary' }
                        onClick={ () => setFont('icomoon') }
                    >
                        { t('settings.mobile.navigation.icon_icomoon') }
                    </Button>
                    <Button
                        type="button"
                        size="sm"
                        color="secondary"
                        className={ icon?.type === 'logo' ? 'is-logo-current' : undefined }
                        onClick={ () => onSelect({ type: 'logo' }) }
                    >
                        <ExploritNavIcon icon={ { type: 'logo' } } logoUri={ logoUri } />
                        <span>{ t('settings.mobile.navigation.icon_logo') }</span>
                    </Button>
                </ButtonGroup>
                <Input
                    className="glyph-chooser-search"
                    type="search"
                    value={ query }
                    placeholder={ t('settings.mobile.navigation.icon_search') }
                    onChange={ (event) => setQuery(event.target.value) }
                />
                <div className="glyph-chooser-grid">
                    { visible.map((name) => (
                        <button
                            key={ name }
                            type="button"
                            className={ `glyph-choice${is_current(font, name) ? ' is-current' : ''}` }
                            title={ name }
                            onClick={ () => onSelect({ type: font, name }) }
                        >
                            <ExploritNavIcon icon={ { type: font, name } } />
                            <span>{ name }</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NavGlyphPicker;
